(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/recurring-wager-reminders.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/recurring-wager-reminders.js');
'use strict';

const {
  Fieldset
} = svs.ui.reactForm;

const RecurringWagerReminders = _ref => {
  let {
    children
  } = _ref;
  return React.createElement(Fieldset, {
    legend: "P\xE5minnelser",
    srOnly: true
  }, children);
};
svs.myProfile.react.pages.notifications.components.RecurringWagerReminders = RecurringWagerReminders;

 })(window);